import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import { COLOR } from '@src/styles/color';

const StyledAudioList = styled(Box)`
  padding: 0px 24px 0 24px;
  background-color: ${COLOR.white};
  border-radius: 12px;
  width: 100%;
  gap: 16px;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  max-height: 100%;
  overflow: hidden;
  animation: fadeInUp 300ms ease-out;

  .audio-list-scroll {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    padding-right: 8px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    box-sizing: border-box;
    padding: 0 12px 24px 0;
  }

  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(12px);
    }

    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

const StyledAudioItem = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 16px;
  border-radius: 12px;
  border: 1px solid ${COLOR.secondary[16]};
  background-color: ${COLOR.white};
  width: 100%;
  box-sizing: border-box;

  .audio-item-content {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    flex: 1;
    overflow: hidden;
  }

  .file-type-icon {
    position: relative;
    width: 40px;
    height: 40px;
    flex-shrink: 0;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
      display: block;
    }

    .file-type-label {
      position: absolute;
      bottom: 4px;
      left: 4px;
      padding: 2px 4px;
      border-radius: 4px;
      font-size: 10px;
      font-weight: 600;
      background: linear-gradient(180deg, #0e0f11 0%, #686f7c 100%);
      color: ${COLOR.white};
    }
  }

  .audio-item-info {
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 0;
    flex: 1;
    overflow: hidden;
  }

  .audio-item-name {
    display: block;
    width: 100%;
    max-width: 100%;
    min-width: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    box-sizing: border-box;
  }

  .audio-item-meta {
    display: flex;
    align-items: center;
    gap: 4px;
    flex-wrap: wrap;
  }

  .audio-item-dot {
    width: 4px;
    height: 4px;
    margin: 2px;
    border-radius: 50%;
    background-color: ${COLOR.indigo[16]};
  }

  .audio-item-meta-status {
    display: flex;
    align-items: center;
    gap: 4px;
    color: inherit;

    svg {
      font-size: 16px;
    }
  }

  .status-spinner {
    position: relative;
    display: inline-flex;
    width: 16px;
    height: 16px;
  }

  .status-spinner-bar {
    position: absolute;
    left: calc(50% - 1px);
    top: 1px;
    width: 2px;
    height: 5px;
    border-radius: 1px;
    background-color: ${COLOR.blueV2};
    transform-origin: center 5px;
    opacity: 0.25;
    animation: status-spinner-fade 0.64s linear infinite;
  }

  @keyframes status-spinner-fade {
    0% {
      opacity: 1;
    }

    100% {
      opacity: 0.15;
    }
  }

  .audio-item-status-text {
    white-space: nowrap;
  }

  .status-progress {
    color: ${COLOR.blueV2};
  }

  .audio-item-actions {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
  }

  .action-button {
    width: 32px;
    height: 32px;
    border-radius: 8px;
    border: 1px solid ${COLOR.secondary[16]};
    padding: 4px;
    color: ${COLOR.indigo.default};
    transition: background-color 0.2s ease, border-color 0.2s ease;

    &:hover {
      background-color: ${COLOR.indigo[4]};
      border-color: ${COLOR.indigo[32]};
    }

    &:focus-visible {
      outline: none;
      border-color: ${COLOR.indigo.default};
    }

    svg {
      font-size: 20px;
    }
  }
`;

export { StyledAudioList, StyledAudioItem };
